// extracted by mini-css-extract-plugin
export default {"container":"video_container__1DsbE","video":"video_video__2ZMD3","nflTheme":"video_nflTheme__3YvOj"};